const Catch = fn =>
  function(...args) {
    try {
      fn.apply(this, args);
      console.log("GA success", fn.name, args);
    } catch (e) {
      console.error("GA error:", e);
    }
    return;
  };

const GA = {
  addToCart: Catch(function _addToCart(product, qty) {
    window.ga("ec:addProduct", {
      id: product.id,
      name: product.name,
      category: product.label,
      brand: product.store.name,
      price: product.price,
      quantity: qty
    });
    window.ga("ec:setAction", "add");
    window.ga("send", "event", "Click", "Cart", "Add", product.id);
  }),
  removeFromCart: Catch(function _removeFromCart(product, qty) {
    window.ga("ec:addProduct", {
      id: product.id + "",
      name: product.name,
      category: product.label,
      brand: product.store.name,
      price: product.price + "",
      quantity: qty + ""
    });
    window.ga("ec:setAction", "remove");
    window.ga("send", "event", "Click", "Cart", "Remove", product.id);
  }),
  purchase: Catch(function _purchase(order = {}) {
    let items = order._parsedCart.items || [];
    if (items.length > 0) {
      items.map(item => {
        window.ga("ec:addProduct", {
          id: item.product.id + "",
          name: item.product.name,
          category: item.product.label,
          brand: item.product.store.name,
          price: item.product.price + "",
          quantity: item.config.quantity + ""
        });
      });
      window.ga("ec:setAction", "purchase", {
        id: order.id + "",
        affiliation: "Hecafe",
        revenue: order.amount + "",
        tax: "0",
        shipping: "0"
      });
    }
    window.ga("send", "pageview");
  }),
  addImpression: Catch(function _addImpression(
    item,
    position = undefined,
    from = ""
  ) {
    window.ga("ec:addImpression", {
      id: item.id, // Product ID (string).
      name: item.name, // Product name (string).
      category: item.label, // Product category (string).
      brand: item.store.name, // Product brand (string).
      list: "Search Results", // Product list (string).
      ...(position !== undefined ? { position } : {}) // Product position (number).
    });
    window.ga("send", "event", from + "-Impression", "Product", item.name);
    window.ga("send", "pageview");
  }),
  searchResultClick: Catch(function _searchResultClick() {
    // TODO: not sure bind to where ?
  }),
  checkout: Catch(function _checkout(items = [], step, payment = "-") {
    if (items.length > 0) {
      items.map(item => {
        window.ga("ec:addProduct", {
          id: item.product.id + "",
          name: item.product.name,
          category: item.product.label,
          brand: item.product.store.name,
          price: item.product.price + "",
          quantity: item.config.quantity + ""
        });
      });
      window.ga("ec:setAction", "checkout", {
        step,
        option: payment
      });
      window.ga("send", "pageview");
    }
  }),
  customEvent: Catch(function _customEvent(category, action, label, value) {
    if (label != null && value != null) {
      window.ga("send", "event", category, action, label, value);
      return;
    }

    if (label != null) {
      window.ga("send", "event", category, action, label);
      return;
    }

    window.ga("send", "event", category, action);
  })
};

export default GA;
